/*
 * ProductQuestionFlow Messages
 *
 * This contains all the text for the ProductQuestionFlow container.
 */

import {defineMessages} from "react-intl";

export const scope = "app.containers.ProductQuestionFlow";

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "This is the ProductQuestionFlow container!",
  },
  dropZoneText: {
    id: `${scope}.dropZoneText`,
    defaultMessage: "Drag and drop files or click to select",
  },
  dropZoneTextActive: {
    id: `${scope}.dropZoneTextActive`,
    defaultMessage: "Drop the files here ...",
  },
  addImplant: {
    id: `${scope}.addImplant`,
    defaultMessage: "Add Implant",
  },

  rightSide: {
    id: `${scope}.rightSide`,
    defaultMessage: "Right side",
  },

  leftSide: {
    id: `${scope}.leftSide`,
    defaultMessage: "Left side",
  },
  frontSide: {
    id: `${scope}.frontSide`,
    defaultMessage: "Front side",
  },
  front: {
    id: `${scope}.front`,
    defaultMessage: "Front",
  },
  back: {
    id: `${scope}.back`,
    defaultMessage: "Back",
  },

  right: {
    id: `${scope}.right`,
    defaultMessage: "Right",
  },

  left: {
    id: `${scope}.left`,
    defaultMessage: "Left",
  },

  implant: {
    id: `${scope}.implant`,
    defaultMessage: "IMPLANT #{id}",
  },
  errorMessage: {
    id: `${scope}.errorMessage`,
    defaultMessage:
      "Select at least 1 implant and fill in either the reference or brand, type and diameter",
  },
  errorMessageTeeth: {
    id: `${scope}.errorMessageTeeth`,
    defaultMessage: "You are required to select at least 1 tooth",
  },

  selectedTeeth: {
    id: `${scope}.selectedTeeth`,
    defaultMessage: "Selected teeth",
  },

  uploadSkip: {
    id: `${scope}.uploadSkip`,
    defaultMessage: "You must upload documents first or skip this step",
  },
  skip: {
    id: `${scope}.skip`,
    defaultMessage: "Skip",
  },
  addSTL: {
    id: `${scope}.addSTL`,
    defaultMessage: "You need to add STL-files first",
  },
  digitalEnable: {
    id: `${scope}.digitalEnable`,
    defaultMessage:
      "Do you want to apply additional changes digitally to your registrations?",
  },
  digitalConfirm: {
    id: `${scope}.digitalConfirm`,
    defaultMessage: "Apply additional changes",
  },
  warningUpload: {
    id: `${scope}.warningUpload`,
    defaultMessage:
      "If you proceed with this action your files that are not ready uploading yet will be deleted.",
  },
  document_order_modal_title: {
    id: `${scope}.document_order_modal_title`,
    defaultMessage: "No other new data received",
  },
  document_order_modal_title2: {
    id: `${scope}.document_order_modal_title2`,
    defaultMessage: "Record data needs to be added later",
  },
  document_order_modal_message: {
    id: `${scope}.document_order_modal_message`,
    defaultMessage:
      "Are you sure you do not want to send new record data for making this order?",
  },
  document_order_modal_message2: {
    id: `${scope}.document_order_modal_message2`,
    defaultMessage:
      "NOTE: the case is ON-HOLD. You must add the data of the records via the message inbox to complete the order and have it produced. Only then a final delivery date can be issued.",
  },
  ok: {
    id: `${scope}.ok`,
    defaultMessage: "Ok",
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: "Cancel",
  },
  upperJaw: {
    id: `${scope}.upperJaw`,
    defaultMessage: "UJ",
  },
  lowerJaw: {
    id: `${scope}.lowerJaw`,
    defaultMessage: "LJ",
  },
});
